const state = () => ({
  dialogHeaderType: 'information',
  dialogLeftHeaderIcon: '',
  dialogTitle: '',
  dialogButtons: [],
  clickBack: undefined,
  showBackArrow: false,
  dialogLeftHeaderIconType: 'static',
  dialogLeftHeaderIconComponent: ''
});

const getters = {
  dialogHeaderType(state) {
    return state.dialogHeaderType;
  },
  dialogLeftHeaderIcon(state) {
    return state.dialogLeftHeaderIcon;
  },
  dialogTitle(state) {
    return state.dialogTitle;
  },
  dialogButtons(state) {
    return state.dialogButtons;
  },
  clickBack(state) {
    return state.clickBack;
  },
  showBackArrow(state) {
    return state.showBackArrow;
  },
  dialogLeftHeaderIconType(state) {
    return state.dialogLeftHeaderIconType;
  },
  dialogLeftHeaderIconComponent(state) {
    return state.dialogLeftHeaderIconComponent;
  }
};

const mutations = {
  setDialogHeaderType(state, payload) {
    state.dialogHeaderType = payload;
  },
  setDialogLeftHeaderIcon(state, payload) {
    state.dialogLeftHeaderIcon = payload;
  },
  setDialogTitle(state, payload) {
    state.dialogTitle = payload;
  },
  setDialogButtons(state, payload) {
    state.dialogButtons = payload;
  },
  setClickBack(state, payload) {
    state.clickBack = payload;
  },
  setShowBackArrow(state, payload) {
    state.showBackArrow = payload;
  },
  setDialogLeftHeaderIconType(state, payload) {
    state.dialogLeftHeaderIconType = payload;
  },
  setDialogLeftHeaderIconComponent(state, payload) {
    state.dialogLeftHeaderIconComponent = payload;
  }
};

const actions = {
  setDialogHeaderType({ commit }, payload) {
    commit('setDialogHeaderType', payload);
  },
  setDialogTitle({ commit }, payload) {
    commit('setDialogTitle', payload);
  },
  setDialogButtons({ commit }, payload) {
    commit('setDialogButtons', payload);
  },
  setClickBack({ commit }, payload) {
    commit('setClickBack', payload);
  },
  setDialogLeftHeaderIcon({ commit }, payload) {
    commit('setDialogLeftHeaderIcon', payload);
  },
  setShowBackArrow({ commit }, payload) {
    commit('setShowBackArrow', payload);
  },
  setDialogLeftHeaderIconType({ commit }, payload) {
    commit('setDialogLeftHeaderIconType', payload);
  },
  setDialogLeftHeaderIconComponent({ commit }, payload) {
    commit('setDialogLeftHeaderIconComponent', payload);
  }
};

export const bloodTestForm = {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
};
